import { render, staticRenderFns } from "./BillGiftModal.vue?vue&type=template&id=32498c30&scoped=true"
import script from "./BillGiftModal.vue?vue&type=script&lang=js"
export * from "./BillGiftModal.vue?vue&type=script&lang=js"
import style0 from "./BillGiftModal.vue?vue&type=style&index=0&id=32498c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32498c30",
  null
  
)

export default component.exports